// Bilingual content model for LEBOURGEOIS GROUP - single source of truth.

export const UNIVERSES = [
  {
    num: "01",
    slug: "wine",
    nameFr: "Vins & Spiritueux",
    nameEn: "Wines & Spirits",
    descFr: "Cuvées rares et maisons de caractère, sélectionnées bouteille par bouteille.",
    descEn: "Rare cuvées and houses of character, selected bottle by bottle.",
  },
  {
    num: "02",
    slug: "head",
    nameFr: "Immobilier",
    nameEn: "Real Estate",
    descFr: "Acquisition et gestion de biens au Luxembourg et à l'international.",
    descEn: "Acquisition and management of property in Luxembourg and abroad.",
  },
  {
    num: "03",
    slug: "sculpture",
    nameFr: "Arts",
    nameEn: "Arts",
    descFr: "Art africain et contemporain, provenance documentée pièce par pièce.",
    descEn: "African and contemporary art, provenance documented piece by piece.",
  },
  {
    num: "04",
    slug: "figures",
    nameFr: "Artisanat",
    nameEn: "Craftsmen & Women",
    descFr: "Ateliers indépendants, savoir-faire documenté et transmis.",
    descEn: "Independent workshops, know-how documented and passed on.",
  },
  {
    num: "05",
    slug: "mask-black",
    nameFr: "Mode",
    nameEn: "Fashion",
    descFr: "Vestiaire sur mesure, matières nobles, séries confidentielles.",
    descEn: "Made-to-measure wardrobe, noble materials, confidential series.",
  },
  {
    num: "06",
    slug: "headdress",
    nameFr: "Parfums & Cosmétiques",
    nameEn: "Parfumes & Cosmetics",
    descFr: "Formulations exigeantes, principe de précaution appliqué.",
    descEn: "Demanding formulations, precautionary principle applied.",
  },
  {
    num: "07",
    slug: "mask-baule",
    nameFr: "Diamants & Or",
    nameEn: "Diamonds & Gold",
    descFr: "Pierres et métaux sourcés selon notre code de conduite.",
    descEn: "Stones and metals sourced under our code of conduct.",
  },
  {
    num: "08",
    slug: "mask-dan",
    nameFr: "Souvenirs",
    nameEn: "Souvenirs",
    descFr: "Objets de mémoire, éditions limitées signées par nos artisans.",
    descEn: "Objects of memory, limited editions signed by our artisans.",
  },
];

export const GALLERY = [
  { id: "g1", slug: "wine", cat: "wines", titleFr: "Cuvée Duché", titleEn: "Duché Vintage", noteFr: "Cuvée Duché · Vins & Spiritueux", noteEn: "Duché Vintage · Wines & Spirits" },
  { id: "g2", slug: "mask-black", cat: "arts", titleFr: "Masque et volumes", titleEn: "Mask & volumes", noteFr: "Masque et volumes · Arts", noteEn: "Mask & volumes · Arts" },
  { id: "g3", slug: "sculpture", cat: "arts", titleFr: "Sculpture cornes", titleEn: "Horned sculpture", noteFr: "Sculpture cornes · Arts", noteEn: "Horned sculpture · Arts" },
  { id: "g4", slug: "headdress", cat: "arts", titleFr: "Coiffe cérémonielle", titleEn: "Ceremonial headdress", noteFr: "Coiffe cérémonielle · Arts", noteEn: "Ceremonial headdress · Arts" },
  { id: "g5", slug: "head", cat: "arts", titleFr: "Tête sur socle", titleEn: "Head on plinth", noteFr: "Tête sur socle · Arts", noteEn: "Head on plinth · Arts" },
  { id: "g6", slug: "figures", cat: "arts", titleFr: "Couple de figures", titleEn: "Pair of figures", noteFr: "Couple de figures · Artisanat", noteEn: "Pair of figures · Craft" },
  { id: "g7", slug: "mask-dan", cat: "arts", titleFr: "Masque Dan", titleEn: "Dan Mask", noteFr: "Masque Dan · Souvenirs", noteEn: "Dan Mask · Souvenirs" },
  { id: "g8", slug: "mask-baule", cat: "arts", titleFr: "Masque à parures", titleEn: "Adorned mask", noteFr: "Masque à parures · Diamants & Or", noteEn: "Adorned mask · Diamonds & Gold" },
];

// Opening carousel (#pieces) - two colour event slides (kept in colour on purpose)
export const OPENER = [
  { src: "/assets/tboca-2.jpg", duration: 10000, uni: "LEBOURGEOIS GROUP", nameFr: "The Best of Congo Awards", nameEn: "The Best of Congo Awards", descFr: "La maison sur le tapis rouge des The Best of Congo Awards, ses cuvées à la main.", descEn: "The house on the red carpet at The Best of Congo Awards, its bottles in hand." },
  { src: "/assets/tboca-1.jpg", duration: 4000, uni: "LEBOURGEOIS GROUP", nameFr: "Duché Royal", nameEn: "Duché Royal", descFr: "Le crémant de la maison, présenté aux The Best of Congo Awards.", descEn: "The house crémant, presented at The Best of Congo Awards." },
];

// Business Club membership tiers (#club)
export const CLUB_TIERS = [
  {
    rank: "I", nameFr: "Premium", nameEn: "Premium", priceFr: "1 500 € / an", priceEn: "EUR 1,500 / year",
    taglineFr: "L'entrée dans le cercle.", taglineEn: "Entry to the circle.",
    includedFr: null, includedEn: null, invert: false, badge: false,
    featsFr: [
      "Conseil à l'ouverture de société au Luxembourg",
      "Développement stratégique et accompagnement de croissance",
      "Accès aux rencontres privées du club",
      "Ligne directe avec l'équipe LEBOURGEOIS",
    ],
    featsEn: [
      "Advice on setting up a company in Luxembourg",
      "Strategic development and growth support",
      "Access to the club's private gatherings",
      "Direct line to the LEBOURGEOIS team",
    ],
  },
  {
    rank: "II", nameFr: "Or", nameEn: "Gold", priceFr: "3 000 € / an", priceEn: "EUR 3,000 / year",
    taglineFr: "Le passage à l'exécution.", taglineEn: "From advice to execution.",
    includedFr: "Tout le niveau PREMIUM, et :", includedEn: "Everything in PREMIUM, plus:", invert: false, badge: false,
    featsFr: [
      "Ouverture de votre société luxembourgeoise (constitution, statuts, domiciliation, immatriculation)",
      "Conférence annuelle du Business Club, place nominative",
      "Accompagnement administratif et mise en relation ciblée",
    ],
    featsEn: [
      "Incorporation of your Luxembourg company (formation, articles, domiciliation, registration)",
      "Annual Business Club conference, named seat",
      "Administrative support and targeted introductions",
    ],
  },
  {
    rank: "III", nameFr: "Diamant", nameEn: "Diamond", priceFr: "5 000 € / an", priceEn: "EUR 5,000 / year",
    taglineFr: "Le cercle restreint.", taglineEn: "The inner circle.",
    includedFr: "Tout le niveau OR, et :", includedEn: "Everything in GOLD, plus:", invert: true, badge: true,
    featsFr: [
      "Accès au cercle d'investisseurs du club",
      "Golf Community, parcours et rencontres à huis clos",
      "Accompagnement à l'ouverture de compte bancaire luxembourgeois",
      "Structuration multi-juridictionnelle : Luxembourg, États-Unis, Congo et au-delà",
    ],
    featsEn: [
      "Access to the club's circle of investors",
      "Golf Community, rounds and closed-door meetings",
      "Support opening a Luxembourg bank account",
      "Multi-jurisdictional structuring: Luxembourg, United States, Congo and beyond",
    ],
  },
];

export const PILLARS = [
  { num: "01", fr: "Autonomie de décision pour chaque maison", en: "Decision autonomy for every house" },
  { num: "02", fr: "Sélection des matières et des fournisseurs", en: "Selection of materials and suppliers" },
  { num: "03", fr: "Code de conduite et traçabilité des ressources", en: "Code of conduct and traceability of resources" },
];

export const COMMITMENTS = [
  { fig: "8", labelFr: "Univers d'expertise", labelEn: "Fields of expertise", bodyFr: "Des vins et spiritueux aux souvenirs, chaque secteur a ses propres experts.", bodyEn: "From wines and spirits to souvenirs, each sector has its own experts." },
  { fig: "100%", labelFr: "Principe de précaution", labelEn: "Precautionary principle", bodyFr: "Appliqué à la conception et à la production, pour la santé et la sécurité des clients.", bodyEn: "Applied to design and production, for the health and safety of clients." },
  { fig: "1er", labelFr: "Critère : la matière", labelEn: "Criterion: the material", bodyFr: "Sourcing exigeant et durable des matières premières de haute qualité.", bodyEn: "Demanding, sustainable sourcing of high-quality raw materials." },
  { fig: "0", labelFr: "Code de conduite", labelEn: "Code of conduct", bodyFr: "Les principes portés par le groupe s'appliquent à toute la chaîne, sans exception.", bodyEn: "The group's principles apply across the whole chain, without exception.", suffixFr: "compromis", suffixEn: "compromise" },
];

export const T = {
  fr: {
    nav: { maison: "La Maison", univers: "Univers", club: "Business Club", galerie: "Galerie", fondateur: "Fondateur", contact: "Contact" },
    heroLead:
      "LEBOURGEOIS GROUP réunit huit maisons au Luxembourg : vins et spiritueux, immobilier, arts, artisanat, mode, parfums et cosmétiques, diamants et or, souvenirs. Chacune garde ses ateliers, ses fournisseurs et son rythme. Toutes répondent du même niveau d'exigence.",
    ctaUnivers: "Découvrir nos univers",
    ctaManifeste: "Notre manifeste",
    ctaGalerie: "La galerie",
    maisonKicker: "LE GROUPE",
    piecesKicker: "PIÈCES SIGNATURE",
    piecesTitle: ["Les ", "signatures", " de la maison."],
    piecesCta: "Voir la pièce",
    clubKicker: "LE CERCLE D'AFFAIRES",
    clubTitle: [["ON N'ENTRE PAS DANS LE CLUB,"], ["on y est ", "admis."]],
    clubLead: "Un cercle fermé d'entrepreneurs et d'investisseurs entre le Luxembourg, l'Europe et l'Afrique. Trois niveaux d'adhésion. Une seule voie d'accès : la candidature.",
    clubCta: "Demander une admission",
    clubBadge: "Places limitées",
    clubLegal: "Cotisation annuelle. Admission sur candidature et cooptation. Le club se réserve le droit de refuser une candidature sans avoir à en motiver la décision.",
    adhesionKicker: "ADHÉSION",
    adhesionTitle: [["VOTRE CANDIDATURE A ÉTÉ ", "retenue", "."]],
    adhesionLead: "Il ne reste qu'à régler votre cotisation annuelle pour que votre adhésion prenne effet.",
    adhesionCta: "Régler ma cotisation",
    adhesionLegal: "Paiement sécurisé par Stripe. Cotisation annuelle, reconduite chaque année, résiliable à tout moment. Les prix s'entendent hors TVA applicable.",
    confirmKicker: "ADHÉSION",
    confirmTitle: [["BIENVENUE AU ", "cercle", "."]],
    confirmP1: "Votre cotisation a bien été enregistrée et votre adhésion prend effet immédiatement.",
    confirmP2: "Vous recevrez sous peu un message de confirmation ainsi que les informations d'accès aux rencontres du club.",
    confirmSignName: "Mike Kabuya Ntabala",
    confirmSignRole: "Fondateur & Directeur",
    confirmBack: "Retour à l'accueil",
    carteKicker: "PRÉSENCE",
    carteTitle: ["Luxembourg, ", "siège", " de la maison."],
    carteCoords: "49.6116° N · 6.1319° E · Grand-Duché de Luxembourg",
    maisonTitle: ["Une communauté ", "créative", ", pas un conglomérat."],
    maisonP1:
      "Le groupe est organisé autour de l'autonomie de ses maisons. Chacune conserve son modèle, ses fournisseurs et sa trajectoire. LEBOURGEOIS GROUP en assure la direction, le financement et la mise en relation, sans uniformiser ce qui fait leur valeur.",
    maisonP2:
      "Les opérations sont décentralisées. Les décisions se prennent au plus près du terrain et du client, ce qui raccourcit les délais et laisse à chaque atelier la marge d'initiative dont dépend son métier.",
    universKicker: "HUIT UNIVERS",
    universTitle: ["Le ", "registre", " de la maison."],
    galerieKicker: "PIÈCES SÉLECTIONNÉES",
    galerieTitle: ["La ", "galerie", "."],
    filters: [{ key: "all", label: "Tout" }, { key: "wines", label: "Vins & Spiritueux" }, { key: "arts", label: "Arts & Artisanat" }],
    founderKicker: "LE FONDATEUR",
    founderQuote:
      "LEBOURGEOIS GROUP réunit des maisons que tout distingue, les métiers, les territoires, les histoires, et leur donne les moyens de durer, sans rien céder de leur identité, de leur héritage ni de leur savoir-faire.",
    founderName: "Mike Ntabala",
    founderRole: "Directeur / Fondateur",
    founderBio: [
      "Mike Ntabala dirige LEBOURGEOIS GROUP depuis le Luxembourg. Économiste et banquier de formation, entrepreneur par nature, il consacre dix-sept années à structurer, financer et développer des entreprises entre l'Europe et l'Afrique.",
      "Sa formation commence à la Haute École de Commerce et de Gestion du Luxembourg (ECG). Elle se poursuit au Canada, à HEC Montréal puis à l'Université de Sherbrooke, avant un retour au Luxembourg\u00A0: économie et management à l'Université du Luxembourg, puis un diplôme en corporate finance et entrepreneuriat obtenu à la Luxembourg School of Business.",
      "Chez BGL BNP Paribas, au client monitoring et à la gestion du risque, il apprend la discipline de l'analyse. En fondant ses propres structures à partir de 2016, il apprend celle de l'exécution.",
      "Deux natures cohabitent chez lui. Celle de l'économiste, façonnée par l'université et la rigueur de l'analyse. Celle de l'entrepreneur, qui ne s'apprend nulle part. La première lui donne la lecture des chiffres et des cycles. La seconde lui donne l'instinct du moment juste.",
      "De cette double culture, entre l'Europe et l'Afrique, naît la ligne de la maison\u00A0: bâtir des activités durables, rentables et évolutives, sans jamais sacrifier l'identité de ceux qui les portent.",
    ],
    founderStats: [
      { num: "LUXEMBOURG", label: "Basé à" },
      { num: "2016", label: "Première structure fondée" },
      { num: "17+", label: "Années d'expérience" },
      { num: "5", label: "Langues parlées" },
    ],
    founderLangs: "Français, lingala, luxembourgeois, allemand, anglais.",
    contactTitle: ["Construisons la ", "suite", " ensemble."],
    formName: "Nom",
    formEmail: "E-mail",
    formUniverse: "Univers concerné",
    formMessage: "Message",
    formSend: "Envoyer",
    formSelect: "Sélectionnez un univers",
    formPhone: "Téléphone",
    formCompany: "Société",
    formNiveau: "Niveau Business Club",
    formSelectNiveau: "Sélectionnez un niveau",
    sending: "ENVOI EN COURS",
    successMsg: "Merci. Votre demande est enregistrée, une réponse suivra sous 48 heures ouvrées.",
    errorMsg: "Une erreur est survenue. Écrivez-nous directement à mike@lebourgeois.lu.",
    toastSent: "Votre message ouvre votre application e-mail.",
    contactHqLabel: "SIÈGE",
    contactHq: "Luxembourg, Grand-Duché de Luxembourg",
    contactEmailLabel: "E-MAIL",
    contactUniversLabel: "NOS UNIVERS",
    footerLead: "Huit maisons, un seul niveau d'exigence.",
    footerNav: "Navigation",
    footerContact: "Contact",
    rights: "© 2026 Lebourgeois Group Luxembourg",
  },
  en: {
    nav: { maison: "The House", univers: "Universe", club: "Business Club", galerie: "Gallery", fondateur: "Founder", contact: "Contact" },
    heroLead:
      "LEBOURGEOIS GROUP brings together eight houses in Luxembourg: wines and spirits, real estate, art, craft, fashion, fragrance and cosmetics, diamonds and gold, keepsakes. Each keeps its own workshops, suppliers and pace. All answer to the same standard.",
    ctaUnivers: "Discover our universes",
    ctaManifeste: "Our manifesto",
    ctaGalerie: "The gallery",
    maisonKicker: "THE GROUP",
    piecesKicker: "SIGNATURE PIECES",
    piecesTitle: ["The house ", "signatures", "."],
    piecesCta: "View the piece",
    clubKicker: "THE INNER CIRCLE",
    clubTitle: [["YOU DON'T JOIN THE CLUB,"], ["you are ", "admitted."]],
    clubLead: "A closed circle of entrepreneurs and investors between Luxembourg, Europe and Africa. Three levels of membership. One way in: application.",
    clubCta: "Request admission",
    clubBadge: "Limited membership",
    clubLegal: "Annual membership fee. Admission by application and co-optation. The club reserves the right to decline an application without stating reasons.",
    adhesionKicker: "ADMISSION",
    adhesionTitle: [["YOUR APPLICATION HAS BEEN ", "accepted", "."]],
    adhesionLead: "All that remains is to settle your annual membership for your admission to take effect.",
    adhesionCta: "Settle my membership",
    adhesionLegal: "Secure payment by Stripe. Annual membership, renewed each year, cancellable at any time. Prices are exclusive of applicable VAT.",
    confirmKicker: "ADMISSION",
    confirmTitle: [["WELCOME TO THE ", "circle", "."]],
    confirmP1: "Your membership fee has been recorded and your admission takes effect immediately.",
    confirmP2: "You will shortly receive a confirmation message along with access details for the club's gatherings.",
    confirmSignName: "Mike Kabuya Ntabala",
    confirmSignRole: "Founder & Director",
    confirmBack: "Back to home",
    carteKicker: "PRESENCE",
    carteTitle: ["Luxembourg, ", "home", " of the house."],
    carteCoords: "49.6116° N · 6.1319° E · Grand Duchy of Luxembourg",
    maisonTitle: ["A ", "creative", " community, not a conglomerate."],
    maisonP1:
      "The group is built around the autonomy of its houses. Each keeps its own model, its own suppliers and its own trajectory. LEBOURGEOIS GROUP provides direction, financing and access, without standardising what makes them valuable.",
    maisonP2:
      "Operations are decentralised. Decisions are made close to the workshop and to the client, which shortens lead times and leaves each house the room for initiative its craft depends on.",
    universKicker: "EIGHT UNIVERSES",
    universTitle: ["The house ", "registry", "."],
    galerieKicker: "SELECTED PIECES",
    galerieTitle: ["The ", "gallery", "."],
    filters: [{ key: "all", label: "All" }, { key: "wines", label: "Wines & Spirits" }, { key: "arts", label: "Arts & Craft" }],
    founderKicker: "THE FOUNDER",
    founderQuote:
      "LEBOURGEOIS GROUP brings together houses that everything sets apart: trades, territories, histories. It gives them the means to endure, without surrendering anything of their identity, their heritage or their craft.",
    founderName: "Mike Ntabala",
    founderRole: "Director / Founder",
    founderBio: [
      "Mike Ntabala leads LEBOURGEOIS GROUP from Luxembourg. An economist and banker by training, an entrepreneur by nature, he has spent seventeen years structuring, financing and building companies between Europe and Africa.",
      "His education begins at the Haute École de Commerce et de Gestion du Luxembourg (ECG). It continues in Canada, at HEC Montréal and then the University of Sherbrooke, before a return to Luxembourg: economics and management at the University of Luxembourg, then a degree in corporate finance and entrepreneurship obtained at the Luxembourg School of Business.",
      "At BGL BNP Paribas, in client monitoring and risk management, he learns the discipline of analysis. Founding his own companies from 2016, he learns the discipline of execution.",
      "Two natures live side by side in him. That of the economist, shaped by the university and the rigour of analysis. That of the entrepreneur, which is taught nowhere. The first gives him the reading of figures and cycles. The second gives him the instinct for the right moment.",
      "From this dual culture, between Europe and Africa, comes the line of the house: to build businesses that last, that are profitable and that can scale, without ever sacrificing the identity of those who carry them.",
    ],
    founderStats: [
      { num: "LUXEMBOURG", label: "Based in" },
      { num: "2016", label: "First company founded" },
      { num: "17+", label: "Years of experience" },
      { num: "5", label: "Languages spoken" },
    ],
    founderLangs: "French, Lingala, Luxembourgish, German, English.",
    contactTitle: ["Let us build ", "what's next", " together."],
    formName: "Name",
    formEmail: "E-mail",
    formUniverse: "Universe concerned",
    formMessage: "Message",
    formSend: "Send",
    formSelect: "Select a universe",
    formPhone: "Phone",
    formCompany: "Company",
    formNiveau: "Business Club tier",
    formSelectNiveau: "Select a tier",
    sending: "SENDING",
    successMsg: "Thank you. Your request has been recorded, we will reply within 48 business hours.",
    errorMsg: "Something went wrong. Please email us directly at mike@lebourgeois.lu.",
    toastSent: "Your message is opening your e-mail app.",
    contactHqLabel: "HEADQUARTERS",
    contactHq: "Luxembourg, Grand Duchy of Luxembourg",
    contactEmailLabel: "E-MAIL",
    contactUniversLabel: "OUR UNIVERSES",
    footerLead: "Eight houses, one standard.",
    footerNav: "Navigation",
    footerContact: "Contact",
    rights: "© 2026 Lebourgeois Group Luxembourg",
  },
};

export const EMAIL = "mike@lebourgeois.lu";
